var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.83325C4.31671 1.83325 1.33337 4.81659 1.33337 8.49992C1.33337 12.1799 4.31671 15.1666 8.00004 15.1666C11.68 15.1666 14.6667 12.1799 14.6667 8.49992C14.6667 4.81659 11.68 1.83325 8.00004 1.83325ZM6.66671 11.8333L3.33337 8.49992L4.27671 7.55659L6.66671 9.94659L11.7234 4.88992L12.6667 5.83325L6.66671 11.8333Z",
    fill: "#43B077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRight);
export default __webpack_public_path__ + "static/media/icon-right.7727ccd85038df3f15ee2280f464df4a.svg";
export { ForwardRef as ReactComponent };